export interface IMenuItem {
  text: string;
  icon: string;
  route: string;
  isActive?: boolean;
  permission?: string;
}

export interface MenuItem {
  text: string;
  icon: string;
  route: string;
  outlet: string;
  submenu: Array<MenuItem>
}

export interface UserActions {
  text: string;
  icon: string;
  path?: string;
  action: string;
}

export class UserInfos {
  label!: string;
  text!: string;
}

export class RouteInfo {
  path!: string;
  title!: string;
  icon!: string;
  class?: string;
  permission?:string;
}


export const ROUTES: RouteInfo[] = [
  { path: '/dashboard', title: 'Dashboard', icon: 'dashboard', class: '' },
  { path: '/manage-tenants', title: 'Tenant Mode', icon: 'diversity_2', class: '', permission:'tenant' },
  { path: '/all-projects', title: 'Projects', icon: 'content_paste', class: '' },
  { path: '/manage-projects', title: 'Projects Management', icon: 'content_paste', permission:'projectRole', class: '' },
  { path: '/manage-users', title: 'Users Management', icon: 'group', permission:'usersRole', class: '' },
  { path: '/manage-platform-grouproles', title: 'Platform Group Roles', icon: 'archive', permission:'dbRole', class: '' },
  { path: '/database-migrations', title: 'Database Migrations', icon: 'storage', permission:'dbRole', class: '' },
];

export const ROUTES_0: RouteInfo[] = [
  { path: '/dashboard', title: 'Dashboard', icon: 'dashboard', class: '' },
];

export const ROUTES_1: RouteInfo[] = [
  { path: '/dashboard', title: 'Dashboard', icon: 'dashboard', class: '' },
  { path: '/manage-tenants', title: 'Tenant', icon: 'diversity_2', class: '', permission:'tenant' }
];

export const ROUTES_2: RouteInfo[] = [
  { path: '/dashboard', title: 'Dashboard', icon: 'dashboard', class: '' },
  { path: '/all-projects', title: 'Projects', icon: 'content_paste', class: '' },
  { path: '/manage-projects', title: 'Projects Management', icon: 'content_paste', permission:'projectRole', class: '' },
  { path: '/manage-users', title: 'Users Management', icon: 'group', permission:'usersRole', class: '' },
  { path: '/manage-platform-grouproles', title: 'Platform Group Roles', icon: 'archive', permission:'dbRole', class: '' },
  { path: '/database-migrations', title: 'Database Migrations', icon: 'storage', permission:'dbRole', class: '' },
];

export const USERACTIONS: UserActions[] = [
  { text: 'SIGNOUT', icon: 'power_settings_new', path: '/signout', action: 'logout()' },
  // { text: 'USERPROFILE', icon: 'account_circle', path: '/user-profile', action: 'openUserProfileDialog()' },
  { text: 'USERPROFILE', icon: 'account_circle', path: '/user-show-profile', action: 'openUserProfileDialog()' },
  { text: 'CHANGEPSWD', icon: 'enhanced_encryption', path: '/user-change-password', action: 'openChangePasswordDialog()' },
  //{ text: 'SETTINGS', icon: 'settings', path: '/settings', action: 'openAppSettingsDialog()' },
];

export const SIGNOUT: UserActions[] = [
  { text: 'SIGNOUT', icon: 'power_settings_new', path: '/signout', action: 'logout()' }
];

// export const USERINFOS: UserInfos[] = [
//   { text: 'USERPROFILE', icon: 'account_circle', path: '/user-profile', action: 'openUserProfileDialog()' },
//   { text: 'CHANGEPSWD', icon: 'enhanced_encryption', path: '/change-password', action: 'openChangePasswordDialog()' },
//   { text: 'SETTINGS', icon: 'settings', path: '/settings', action: 'openAppSettingsDialog()' },
//   { text: 'SIGNOUT', icon: 'power_settings_new', path: '/signout', action: 'logout()' }
// ];